var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('img',{attrs:{"alt":"STW","id":"logo","src":"https://logodownload.org/wp-content/uploads/2015/12/Star-Wars-Logo-9.png"}})])}]

export { render, staticRenderFns }